export class PaypalOption {
  clientId;
  currency;
  description;
  downSpeedTransformedValue;
  downSpeedUnitType;
  downSpeedValue;
  downloadTransformedValue;
  downloadUnitType;
  downloadValue;
  enabled;
  id;
  name;
  objectType;
  price;
  timeLimitTransformedValue;
  timeLimitUnitType;
  timeLimitValue;
  constructor(obj?: PaypalOption) {
    for (const prop in obj) {
      if (obj.hasOwnProperty(prop)) {
        this[prop] = obj[prop];
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/paypal-options/paypal-option.model.ts